// extracted by mini-css-extract-plugin
module.exports = {"Container":"AuthView_Container__1UD19","AuthBox":"AuthView_AuthBox__g2Brc","Logo":"AuthView_Logo__mMNkg"};